import { QuizImportMethods } from '@showbie-socrative/socrative-utils';

import { teacherServiceURL } from '../endpoint';

/**
 * Adapted from `constants.js`
 */
enum ImportType {
  SocType = 1,
  SpreadsheetType = 2,
}

export const quizURL = () => new URL('quizzes', teacherServiceURL);

export const quizLimitURL = () => {
  const url = quizURL();
  url.pathname += '/limits';
  return url;
};

export const v3QuizURL = () => new URL('/v3/quizzes/', teacherServiceURL);

export const importQuizURL = (type: number, method?: QuizImportMethods) => {
  const url = v3QuizURL();
  url.pathname += 'import';
  url.searchParams.append('type', String(type));
  if (method) {
    url.searchParams.append('method', method);
  }
  return url;
};

export const importQuizBySocURL = (method: QuizImportMethods) =>
  importQuizURL(ImportType.SocType, method);

export const importQuizBySpreadsheetURL = () =>
  importQuizURL(ImportType.SpreadsheetType);

/**
 * this url is used for moving and deleting.
 */
export const moveURL = () => {
  const url = v3QuizURL();
  url.pathname += 'move';
  return url;
};

export const purgeURL = () => {
  const url = v3QuizURL();
  url.pathname += 'purge';
  return url;
};

export const mergeURL = () => {
  const url = v3QuizURL();
  url.pathname += 'merge';
  return url;
};

export function copyURL() {
  const url = v3QuizURL();
  url.pathname += 'copy';
  return url;
}
